import { P2GBox } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { GroupingPanel } from '../panels/GroupingPanel';
import { SmartSendItemGroup } from './SmartSendGroup';
import { P2GButton } from '@parcel2go/core-ui';
import SmartSendGroupExtras from './SmartSendGroupExtras';
import { SettingsCache } from '~/lib/consts/settings-cache';
import ItemIsReady from '../../../lib/helpers/ItemIsReady';

interface props {
  group: SmartSendItemGroup;
  isXs: boolean;
  children?: React.ReactNode;
}

export default function SmartSendGroupFooter(props: props) {
  const enabled = useMemo(
    () =>
      SettingsCache.settings.Features.includes('GroupExtras') &&
      props.group.Items.length > 1 &&
      props.group.Items.filter(ItemIsReady).length == props.group.Items.length,
    [props.group.Items]
  );

  if (!props.group.IsGroupable) {
    return enabled ? (
      <SmartSendGroupExtras group={props.group} isXs={props.isXs}>
        {props.children}
      </SmartSendGroupExtras>
    ) : null;
  }

  return (
    <P2GBox p={3} textAlign="center">
      <GroupingPanel
        group={props.group}
        control={
          <P2GBox>
            <P2GButton variant="primary">Group {props.group.Items.length} items</P2GButton>
          </P2GBox>
        }
      />
    </P2GBox>
  );
}
